import { PokeNames } from "types/pokemon/poke-names";
import { PokeType } from "types/pokemon/poke-type";
import { PackTier } from "utils/pokemon/pack-tier-classifier";

export enum PackKind {
  NORMAL = "NORMAL",
  ENERGY_ONLY = "ENERGY_ONLY",
}

export enum PackVariant {
  BASE = "BASE",
  SHINY_BOOST = "SHINY_BOOST",
  TALENT_BOOST = "TALENT_BOOST",
}

/**
 * core-packs (C2) static pack content. `pool` is hand-curated (see
 * `utils/pokemon/pack-coverage.ts` for the tool that tracks curation coverage) --
 * never mechanically generated.
 */
export interface PackDefinition {
  key: string;
  name: string;
  kind: PackKind;
  types: PokeType[];
  tier?: PackTier;
  variant?: PackVariant;
  pool?: PokeNames[];
  shiny_rate_multiplier?: number;
  talent_purity_bias?: number;
  energy_amount?: number;
}
